export default "__VITE_ASSET__VvMXunwd__"